import { useEffect } from 'react';

/**
 * Web Vitals Monitoring Component
 * Tracks Core Web Vitals: LCP, FID, CLS, FCP, TTFB
 */
const WebVitals = () => {
  useEffect(() => {
    // Only track in production
    if (process.env.NODE_ENV !== 'production') {
      return;
    }
    
    // Dynamic import of web-vitals
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Send metrics to analytics endpoint
      const sendToAnalytics = (metric: any) => {
        const body = JSON.stringify({
          name: metric.name,
          value: metric.value,
          rating: metric.rating,
          delta: metric.delta,
          id: metric.id,
          timestamp: Date.now(),
          url: globalThis.location.href,
          userAgent: navigator.userAgent
        });
        
        // Send to analytics service (implement your endpoint)
        if (navigator.sendBeacon) {
          navigator.sendBeacon('/api/analytics/vitals', body);
        } else {
          fetch('/api/analytics/vitals', {
            method: 'POST',
            body,
            headers: { 'Content-Type': 'application/json' },
            keepalive: true
          }).catch(console.error);
        }
      };
      
      // Track all Core Web Vitals
      getCLS(sendToAnalytics);  // Cumulative Layout Shift
      getFID(sendToAnalytics);  // First Input Delay
      getFCP(sendToAnalytics);  // First Contentful Paint
      getLCP(sendToAnalytics);  // Largest Contentful Paint
      getTTFB(sendToAnalytics); // Time to First Byte
    });
  }, []);
  
  return null;
};

export default WebVitals;
